import { Component, inject } from "@angular/core";
import { ExportBase } from "../export-base";
import { ExportType } from "@enums/ExportType";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { provideTranslocoScope, TranslocoPipe } from "@jsverse/transloco";
import { FormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";

@Component({
    selector: "export-controls",
    templateUrl: "./export-controls.component.html",
    styleUrls: ["./export-controls.component.scss"],
    providers: [provideTranslocoScope("export")],
    imports: [TranslocoPipe, FormsModule, MatCheckboxModule]
})
export class ExportControlsComponent extends ExportBase {
    includearchivedlinks = true;
    permService = inject(PermissionsService);

    downloadControls(type: ExportType) {
        const extra = `includearchivedlinks=${this.includearchivedlinks}`;
        this.exportDataService.downloadExport(type, extra);
    }
}
